import { render } from "./dataSignal.vue?vue&type=template&id=474018c0&scoped=true"
import script from "./dataSignal.js?vue&type=script&lang=js"
export * from "./dataSignal.js?vue&type=script&lang=js"

import "./dataSignal.vue?vue&type=style&index=0&id=474018c0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-474018c0"]])

export default __exports__